export default "__VITE_ASSET__4a602b16__"